import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ClassyLayoutComponent } from './classy.component';
import { ClipboardComponent } from '../../../common/clipboard/clipboard.component';
import { MessagesModule } from '../../../common/messages/messages.module';
import { FuseFullscreenModule } from '../../../../../@fuse/components/fullscreen/fullscreen.module';
import { FuseLoadingBarModule } from '../../../../../@fuse/components/loading-bar/loading-bar.module';
import { FuseNavigationModule } from '../../../../../@fuse/components/navigation/navigation.module';
import { LanguagesModule } from '../../../common/languages/languages.module';
import { UserModule } from '../../../common/user/user.module';
import { SettingsModule } from '../../../common/settings/settings.module';
import { SystemChangesComponent } from '../../../common/system-changes/system-changes.component';
import { SharedModule } from '../../../../shared/shared.module';
import { WsMessagesComponent } from '../../../common/ws-messages/ws-messages.component';

@NgModule({
    declarations: [
        ClassyLayoutComponent
    ],
    imports     : [
        ClipboardComponent,
        HttpClientModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        MessagesModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        UserModule,
        SettingsModule,
        SystemChangesComponent,
        SharedModule,
        WsMessagesComponent,
    ],
    exports     : [
        ClassyLayoutComponent
    ]
})
export class ClassyLayoutModule
{
}
